module.exports = __webpack_public_path__ + "static/media/icon-sell.0f4f4688.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-sell.svg
// module id = 1250
// module chunks = 19